<template>
  <ul class="sider">
    <side-menu-item v-for="item in menuList" :key="item.name" :name="item.name">
      {{ item.meta.title }}
    </side-menu-item>
  </ul>
</template>

<script>
import "@/styles/component/sider.less";
import Emitter from "@/mixins/emitter";
import sideMenuItem from "./side-menu-item";
// import { mapGetters } from "vuex";
export default {
  name: "sideMenu",
  mixins: [Emitter],
  mounted() {
    // console.log("挂载");
  },
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      }
    },
    activeName: {
      type: String,
      default: ""
    }
  },
  methods: {
    getActiveName(name) {
      return this.$route.matched
        .map(item => item.name)
        .filter(item => item !== name);
    }
  },
  components: {
    sideMenuItem
  },
  watch: {
    activeName(name) {
      let activeName = this.getActiveName(name);
      this.broadcast("side-menu-item", "update-active-name", activeName[0]);
    }
  }
};
</script>
